module.exports = __webpack_public_path__ + "static/img/art.f374c9cd.png";